module.exports = __webpack_public_path__ + "static/media/9.ebdd2743.jpg";